


























































import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
import { detail } from '../api';
import { isWeiXin, inAppAlertLogin, WechatLogin } from '@/common/ts/common';
import { Field, Toast, ImagePreview, Lazyload } from 'vant';
import SyForm from '@/components/SyForm/SyForm.vue';

Vue.use(Field)
  .use(Toast)
  .use(ImagePreview)
  .use(Lazyload);

@Component
export default class Detail extends Vue {
  submitInfo: any = {};
  info: any = [
    {
      title: '基本信息',
      item: [
        {
          text: '照片',
          value: 'cover',
          type: 1, // 上传
        },
        {
          text: '姓名',
          value: 'name',
          type: 2, // 输入框
        },
        {
          text: '曾姓名',
          value: 'old_name',
          type: 2,
        },

        {
          text: '性别',
          value: 'sex',
          type: 2,
        },
        {
          text: '出生日期',
          value: 'year_date',
          type: 2,
        },
        {
          text: '年龄',
          value: 'year',
          type: 2,
        },
        {
          text: '民族',
          value: 'nation',
          type: 2,
        },
        {
          text: '身高',
          value: 'heights',
          type: 2,
        },
        {
          text: '体重',
          value: 'weights',
          type: 2,
        },
        {
          text: '走失日期',
          value: 'lost_date',
          type: 2,
        },
        {
          text: '走失地点',
          value: 'lost_address',
          type: 2,
        },

        {
          text: '口音',
          value: 'accent',
          type: 2,
        },
        {
          text: '情况说明',
          value: 'explain',
          type: 6, // textarea
        },
      ],
    },
    {
      title: '信息特征',
      item: [
        {
          text: '体态',
          value: 'posture',
          type: 2,
        },
        {
          text: '头发曲直',
          value: 'hair_curly',
          type: 2,
        },
        {
          text: '头发颜色',
          value: 'hair_color',
          type: 2,
        },
        {
          text: '血型',
          value: 'blood',
          type: 2,
        },
      ],
    },
    {
      title: '身体残疾',
      item: [
        {
          text: '有无残疾',
          value: 'body_disability',
          type: 2,
        },
      ],
    },
    {
      title: '胎记',
      item: [
        {
          text: '有无胎记',
          value: 'birthmark',
          type: 2,
        },
      ],
    },
    {
      title: '纹身',
      item: [
        {
          text: '有无纹身',
          value: 'tattoo',
          type: 2,
        },
      ],
    },
    {
      title: '肢体残疾',
      item: [
        {
          text: '有无肢体残疾',
          value: 'limbs_disability',
          type: 2,
        },
      ],
    },
    {
      title: '智力残疾',
      item: [
        {
          text: '有无智力残疾',
          value: 'intelligence_disability',
          type: 2,
        },
      ],
    },
    {
      title: '精神状态',
      item: [
        {
          text: '精神状态',
          value: 'mentality',
          type: 2,
        },
      ],
    },
  ];

  async activated() {
    const data = {
      id: this.$route.query.id as string,
    };
    const res: any = await detail(data);
    this.submitInfo = res.data;
    let str = '';
    if (this.submitInfo.residence) {
      this.submitInfo.residence.map((item: any) => {
        str += item;
      });
      this.submitInfo.residence = str;
    }

    this.submitInfo.birthmark === '1'
      ? (this.submitInfo.birthmark = '有')
      : (this.submitInfo.birthmark = '无');
    this.submitInfo.body_disability === '1'
      ? (this.submitInfo.body_disability = '有')
      : (this.submitInfo.body_disability = '无');
    this.submitInfo.tattoo === '1'
      ? (this.submitInfo.tattoo = '有')
      : (this.submitInfo.tattoo = '无');
    this.submitInfo.limbs_disability === '1'
      ? (this.submitInfo.limbs_disability = '有')
      : (this.submitInfo.limbs_disability = '无');
    this.submitInfo.intelligence_disability === '1'
      ? (this.submitInfo.intelligence_disability = '有')
      : (this.submitInfo.intelligence_disability = '无');
    this.submitInfo.mentality === '1'
      ? (this.submitInfo.mentality = '异常')
      : (this.submitInfo.mentality = '正常');
    console.log(11, this.submitInfo);
  }
  getImg(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
}
